import React, { type PropsWithChildren } from "react";

import type { ProcessedSameEventMultiOutcome } from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { ReactComponent as PlaceMedals1 } from "@/features/race/assets/icon-medal1.svg";
import { ReactComponent as PlaceMedals2 } from "@/features/race/assets/icon-medal2.svg";
import { ReactComponent as PlaceMedals3 } from "@/features/race/assets/icon-medal3.svg";
import { ReactComponent as PlaceMedals4 } from "@/features/race/assets/icon-medal4.svg";

import * as styles from "./ExoticOutcome.module.scss";

type ExoticRunnersInPositionProps = {
  outcomes: ProcessedSameEventMultiOutcome[];
  position: number;
  isAnimated?: boolean;
};

type ExoticSelectionsProps = PropsWithChildren<{ className?: string }>;

const ExoticSelections = ({ className, children }: ExoticSelectionsProps) => {
  return (
    <div className={cx(styles.exoticSelections, className)}>{children}</div>
  );
};

const icon: Record<number, React.ReactNode> = {
  1: <PlaceMedals1 />,
  2: <PlaceMedals2 />,
  3: <PlaceMedals3 />,
  4: <PlaceMedals4 />,
};

const ExoticRunnersInPosition = ({
  outcomes,
  position,
}: ExoticRunnersInPositionProps) => {
  const sortedRunners = (outcomes || []).sort(
    (a, b) =>
      parseInt(a.attributes?.runnerNumber ?? "0") -
      parseInt(b.attributes?.runnerNumber ?? "0"),
  );

  return (
    <div className={styles.exoticRunners}>
      <div>{icon[position]}</div>
      <div className={styles.runnersList}>
        {sortedRunners.map((outcome, index) => (
          <div
            key={`runner-${outcome.outcomeId}`}
            className={styles.runnerNumber}
          >
            <div
              className={cx({
                [styles.won]: outcome.outcomeResult === "WIN",
              })}
            >
              {outcome.attributes?.runnerNumber}
            </div>
            {index === sortedRunners.length - 1 ? null : ","}
          </div>
        ))}
      </div>
    </div>
  );
};

export { ExoticRunnersInPosition, ExoticSelections };
